module.exports = __webpack_public_path__ + "static/media/s1.42622c57.jpg";